export default __webpack_public_path__ + "static/media/rain.627f289b.jpg";